import React from 'react';
import Select from 'react-select';
import { Badge } from 'AWS-UI-Components-React';

export class ProductGroupSelection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedProductGroups: null,
      isModified: false,
    };
  }

  onProductGropupSelection = (event) => {
    this.props.onProductGroupSelection(event);
  };

  // react-select calls this for both the menu options and the selected-value chips;
  // the badge must render ONLY in the menu, otherwise it clutters every selected chip.
  formatOptionLabel = (option, { context }) => {
    if (context === 'menu' && option.mappedToId) {
      return (
        <span title={option.mappedToName || undefined}>
          {option.label} <Badge color={'grey'} content={`Mapped to ${option.mappedToId}`} />
        </span>
      );
    }
    return option.label;
  };

  render() {
    const { selectedProductGroups, productGroupOptions } = this.props;

    return (
      <Select
        options={productGroupOptions}
        defaultValue={selectedProductGroups}
        onChange={this.onProductGropupSelection}
        formatOptionLabel={this.formatOptionLabel}
        placeholder={'Select product groups'}
        isMulti
        isDisabled={this.props.disabled}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/config_central/pl_gl_mapping/product_group_selection.jsx